const WHATSAPP_PHONE = "5511964914546";

/** Link do WhatsApp com uma mensagem já preenchida. */
export const whatsappUrlComTexto = (texto: string) =>
  `https://api.whatsapp.com/send?phone=${WHATSAPP_PHONE}&text=${encodeURIComponent(
    texto
  )}`;

export const WHATSAPP_URL = whatsappUrlComTexto(
  "Olá! Quero um orçamento de soluções digitais"
);

export const CNPJ = "66.203.552/0001-05";

export const PLATAFORMAS =
  "Nuvemshop, WooCommerce, Shopify, Wake, Tray, VTEX, Jet e Linx";

export const EMAIL = "projetos@sistemasflex.com.br";

export const AGENDA_URL = "https://calendar.app.google/jWCW7VaB2iGp8C8t5";

export const AGENDA_EMBED_URL =
  "https://calendar.google.com/calendar/appointments/schedules/AcZssZ3wHznluiuHqt2q9TqIpLZKyb4UPK6H41HJ2jOlgfnu5N2Z27x4jLjr1mC-rzlajS6UcG-6P4-M?gv=true";
